
// import { useState } from "react";
// import Select from "../../../components/select";
// import { useDispatch } from "react-redux";
// import arrow from "../../../assets/svg-icons/blueArrow.svg";
// import { Link, useNavigate } from "react-router-dom";
// import { useAuditLogList } from "../layout/resuableEffect";


// const AuditLogs = () => {
//   document.title = "Event Logs - CloudVantage";
  
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const options = [
//     { value: "all-logs", label: "All Event Logs" },
//     { value: "date", label: "Date" }
//   ];

//   const [searchText, setSearchText] = useState("");
  
//   const handleSearchChange = (event) => {
//     setSearchText(event.target.value);
//     setCurrentPage(1);
//   };

//   const auditLogList = useAuditLogList();

//   // Parse timestamp from details field
//   const parseTimestampFromDetails = (details) => {
//     if (!details) return null;
    
//     // Extract timestamp format like: 2025-05-30 09:37:47.494439+00:00
//     const timestampMatch = details.match(/\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}\.\d+\+\d{2}:\d{2}/);
//     if (timestampMatch) {
//       // Replace space with T to make it a valid ISO format
//       const isoTimestamp = timestampMatch[0].replace(' ', 'T');
//       return new Date(isoTimestamp);
//     }
    
//     return null;
//   };
  
//   // Format the date for display
//   const formatDate = (date) => {
//     if (!date || !(date instanceof Date) || isNaN(date)) return "Invalid Date";
    
//     const day = date.getDate();
//     const month = date.toLocaleString('default', { month: 'long' });
//     const year = date.getFullYear();
//     const weekday = date.toLocaleString('default', { weekday: 'long' });
    
//     // Add ordinal suffix to day
//     let suffix = "th";
//     if (day === 1 || day === 21 || day === 31) suffix = "st";
//     else if (day === 2 || day === 22) suffix = "nd";
//     else if (day === 3 || day === 23) suffix = "rd";
    
//     return `${weekday}, ${month} ${day}${suffix}, ${year}`;
//   };
  
//   // Format the time for display
//   const formatTime = (date) => {
//     if (!date || !(date instanceof Date) || isNaN(date)) return "Invalid Time";
    
//     // Format time as HH:MM:SS AM/PM
//     return date.toLocaleTimeString('en-US', { 
//       hour: '2-digit', 
//       minute: '2-digit', 
//       second: '2-digit',
//       hour12: true 
//     });
//   };
  

//   const formatDateForComparison = (date) => {
//     if (!date || !(date instanceof Date) || isNaN(date)) return "";
//     return date.toISOString().toLowerCase();
//   };

//   // Parse created date as fallback
//   const parseCreatedDate = (created) => {
//     if (!created) return null;
    
//     try {
//       // Handle format like "Friday, May 30th, 2025 09:37 AM"
//       // First, let's extract the date components
//       const dateMatch = created.match(/(\w+),\s(\w+)\s(\d+)\w+,\s(\d+)\s(\d+):(\d+)\s(AM|PM)/);
//       if (dateMatch) {
//         const [, weekday, monthName, day, year, hour, minute, ampm] = dateMatch;
        
//         // Convert month name to number
//         const months = {
//           'January': 0, 'February': 1, 'March': 2, 'April': 3, 'May': 4, 'June': 5,
//           'July': 6, 'August': 7, 'September': 8, 'October': 9, 'November': 10, 'December': 11
//         };
        
//         let hour24 = parseInt(hour);
//         if (ampm === 'PM' && hour24 !== 12) hour24 += 12;
//         if (ampm === 'AM' && hour24 === 12) hour24 = 0;
        
//         return new Date(parseInt(year), months[monthName], parseInt(day), hour24, parseInt(minute));
//       }
      
//       // Fallback: try to parse as regular date
//       return new Date(created);
//     } catch (error) {
//       return null;
//     }
//   };

//   // Map the audit log data
//   const auditLogListMap = Array.isArray(auditLogList)
//     ? auditLogList.map((alog, index) => {
//         // const timestamp = parseTimestampFromDetails(alog?.details);
//         return {
//           sn: index + 1,
//           details: alog?.details || "",
//           created: alog?.created || "",
//           // timestamp: timestamp,
//           // date: formatDate(timestamp),
//           // time: formatTime(timestamp)
//         };
//       })
//       // Sort logs by timestamp (newest first) - June 2 before May 30, etc.
//       .sort((a, b) => {
//         // If both have timestamps, sort by timestamp (newest first)
//         if (a.sortTimestamp && b.sortTimestamp) {
//           return b.sortTimestamp - a.sortTimestamp;
//         }
        
//         // If only one has timestamp, prioritize the one with timestamp
//         if (a.sortTimestamp && !b.sortTimestamp) return -1;
//         if (!a.sortTimestamp && b.sortTimestamp) return 1;
        
//         // If neither has timestamp, try to sort by original order (newer entries first)
//         return a.sn - b.sn;
//       })
//       // Re-number after sorting to maintain sequential S/N
//       .map((item, index) => ({ ...item, sn: index + 1 }))
//     : [];

//   const [currentPage, setCurrentPage] = useState(1);
//   const entriesPerPage = 10;

//   const filteredData = auditLogListMap.filter((row) => {
//     const dateStr = row.created.toLowerCase();
//     const detailsStr = row.details.toLowerCase();
//     const searchLower = searchText.toLowerCase();
    
//     return dateStr.includes(searchLower) || 
//            detailsStr.includes(searchLower);
//   });


//   const numberedData = filteredData.map((item, index) => ({
//     ...item,
//     displayNumber: index + 1
//   }));

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredData.length / entriesPerPage);

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   return (
//     <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">
//       <p className="crimson-font text-lg font-medium text-primaryBlue">Event Logs</p>

//       {auditLogListMap?.length > 0 ? (
//         <div>
//           <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
//             <div className="md:col-span-3">
//               <Select label="Filter logs" name="logs" options={options} />
//             </div>
//             <div className="md:col-span-4">
//               <input
//                 type="search"
//                 name="search"
//                 value={searchText}
//                 onChange={handleSearchChange}
//                 placeholder="Search by date, time, or details..."
//                 className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
//               />
//             </div>
//           </div>
          
//           <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
//             <table className="w-full text-sm text-left overflow-hidden">
//               <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
//                 <tr>
//                   <th scope="col" className="px-6 py-4 whitespace-nowrap">
//                     S/N
//                   </th>
//                   <th scope="col" className="px-6 py-4 whitespace-nowrap">
//                     Details
//                   </th>
//                   <th scope="col" className="px-6 py-4 whitespace-nowrap">
//                     Date
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
//                 {currentEntries.map((row, index) => (
//                   <tr
//                     key={index}
//                     className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
//                   >
//                     <td className="text-start py-4 px-6">{row.displayNumber}.</td>
//                     <td className="text-start py-4 px-6">{row.details}</td>
//                     <td className="text-start py-4 px-6">{row.created}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
          
//           <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
//             <p className="text-gray-400 text-sm">
//               Showing{" "}
//               <span className="font-medium text-black dark:text-white">
//                 {indexOfFirstEntry + 1}
//               </span>{" "}
//               to{" "}
//               <span className="font-medium text-black dark:text-white">
//                 {Math.min(indexOfLastEntry, filteredData.length)}
//               </span>{" "}
//               of{" "}
//               <span className="font-medium text-black dark:text-white">
//                 {filteredData.length}
//               </span>{" "}
//               results
//             </p>
//             <div className="flex gap-3">
//               <button
//                 className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${
//                   currentPage === 1 ? "opacity-50" : "opacity-100"
//                 }`}
//                 onClick={handlePreviousPage}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>
//               <button
//                 className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${
//                   currentPage === totalPages ? "opacity-50" : "opacity-100"
//                 }`}
//                 onClick={handleNextPage}
//                 disabled={currentPage === totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="md:px-52 text-center grid text-gray-500 mt-32">
//           <div>
//             It looks like you don't have any event logs yet. Once you have a log, your log details will appear here.
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AuditLogs;

import { useState } from "react";
import Select from "../../../components/select";
import { useDispatch } from "react-redux";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import { Link, useNavigate } from "react-router-dom";
import { useAuditLogList } from "../layout/resuableEffect";

const AuditLogs = () => {
  document.title = "Audit Logs - CloudVantage";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const options = [
    { value: "all-logs", label: "All event logs" },
    { value: "date", label: "Date" },
  ];

  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const auditLogList = useAuditLogList();

  // Parse timestamp from details field
  const parseTimestampFromDetails = (details) => {
    if (!details) return null;

    // Extract timestamp format like: 2025-05-30 09:37:47.494439+00:00
    const timestampMatch = details.match(/\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}\.\d+\+\d{2}:\d{2}/);
    if (timestampMatch) {
      // Replace space with T to make it a valid ISO format
      const isoTimestamp = timestampMatch[0].replace(' ', 'T');
      return new Date(isoTimestamp);
    }

    return null;
  };

  // Format the date for display
  const formatDate = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return "Invalid Date";

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    const weekday = date.toLocaleString('default', { weekday: 'long' });

    // Add ordinal suffix to day
    let suffix = "th";
    if (day === 1 || day === 21 || day === 31) suffix = "st";
    else if (day === 2 || day === 22) suffix = "nd";
    else if (day === 3 || day === 23) suffix = "rd";

    return `${weekday}, ${month} ${day}${suffix}, ${year}`;
  };

  // Format the time for display
  const formatTime = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return "Invalid Time";

    // Format time as HH:MM:SS AM/PM
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  // Clean the details text by removing the timestamp
  const cleanDetails = (details) => {
    if (!details) return "";

    // Remove the timestamp pattern from the details
    return details.replace(/\sat\s\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}\.\d+\+\d{2}:\d{2}/, "").trim();
  };

  // Parse created date as fallback
  const parseCreatedDate = (created) => {
    if (!created) return null;

    try {
      // Handle format like "Friday, May 30th, 2025 09:37 AM"
      // First, let's extract the date components
      const dateMatch = created.match(/(\w+),\s(\w+)\s(\d+)\w+,\s(\d+)\s(\d+):(\d+)\s(AM|PM)/);
      if (dateMatch) {
        const [, weekday, monthName, day, year, hour, minute, ampm] = dateMatch;

        // Convert month name to number
        const months = {
          'January': 0, 'February': 1, 'March': 2, 'April': 3, 'May': 4, 'June': 5,
          'July': 6, 'August': 7, 'September': 8, 'October': 9, 'November': 10, 'December': 11
        };

        let hour24 = parseInt(hour);
        if (ampm === 'PM' && hour24 !== 12) hour24 += 12;
        if (ampm === 'AM' && hour24 === 12) hour24 = 0;

        return new Date(parseInt(year), months[monthName], parseInt(day), hour24, parseInt(minute));
      }

      // Fallback: try to parse as regular date
      return new Date(created);
    } catch (error) {
      return null;
    }
  };

  // Map the audit log data
  const auditLogListMap = Array.isArray(auditLogList)
    ? auditLogList.map((alog, index) => {
        // Try to parse timestamp from details first, fallback to created field
        let timestamp = parseTimestampFromDetails(alog?.details);
        let fallbackTimestamp = null;
        let date = "";
        let time = "";

        if (timestamp) {
          date = formatDate(timestamp);
          time = formatTime(timestamp);
        } else {
          // Parse the created field as fallback
          fallbackTimestamp = parseCreatedDate(alog?.created);
          if (fallbackTimestamp) {
            timestamp = fallbackTimestamp;
            date = formatDate(fallbackTimestamp);
            time = formatTime(fallbackTimestamp);
          } else if (alog?.created) {
            // If parsing fails, use the created field as-is for date
            date = alog.created;
            time = ""; // No separate time available
          }
        }

        return {
          sn: index + 1,
          details: cleanDetails(alog?.details) || alog?.details || "",
          timestamp: timestamp,
          date: date,
          time: time,
          sortTimestamp: timestamp || fallbackTimestamp // Use for sorting
        };
      })
      // Sort logs by timestamp (newest first) - June 2 before May 30, etc.
      .sort((a, b) => {
        // If both have timestamps, sort by timestamp (newest first)
        if (a.sortTimestamp && b.sortTimestamp) {
          return b.sortTimestamp - a.sortTimestamp;
        }

        // If only one has timestamp, prioritize the one with timestamp
        if (a.sortTimestamp && !b.sortTimestamp) return -1;
        if (!a.sortTimestamp && b.sortTimestamp) return 1;

        // If neither has timestamp, try to sort by original order (newer entries first)
        return a.sn - b.sn;
      })
      // Re-number after sorting to maintain sequential S/N
      .map((item, index) => ({ ...item, sn: index + 1 }))
    : [];

  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 10;

  // Filter data based on search text
  const filteredData = auditLogListMap.filter((row) => {
    const dateStr = row.date.toLowerCase();
    const timeStr = row.time.toLowerCase();
    const detailsStr = row.details.toLowerCase();
    const searchLower = searchText.toLowerCase();

    return dateStr.includes(searchLower) ||
           timeStr.includes(searchLower) ||
           detailsStr.includes(searchLower);
  });

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">
      <p className="crimson-font text-lg font-medium text-primaryBlue">Event Logs</p>

      {auditLogListMap?.length > 0 ? (
        <div>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
            <div className="md:col-span-3">
              <Select label="Filter logs" name="logs" options={options} />
            </div>
            <div className="md:col-span-4">
              <input
                type="search"
                name="search"
                value={searchText}
                onChange={handleSearchChange}
                placeholder="Search by date, time, or details..."
                className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
              />
            </div>
          </div>

          <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
            <table className="w-full text-sm text-left overflow-hidden">
              <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                <tr>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    S/N
                  </th>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    Details
                  </th>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    Date
                  </th>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    Time
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                {currentEntries.map((row, index) => (
                  <tr
                    key={index}
                    className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                  >
                    <td className="text-start py-4 px-6">{row?.sn}.</td>
                    <td className="text-start py-4 px-6">{row?.details}</td>
                    <td className="text-start py-4 px-6">{row?.date}</td>
                    <td className="text-start py-4 px-6">{row?.time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
            <p className="text-gray-400 text-sm">
              Showing{" "}
              <span className="font-medium text-black dark:text-white">
                {indexOfFirstEntry + 1}
              </span>{" "}
              to{" "}
              <span className="font-medium text-black dark:text-white">
                {Math.min(indexOfLastEntry, filteredData.length)}
              </span>{" "}
              of{" "}
              <span className="font-medium text-black dark:text-white">
                {filteredData.length}
              </span>{" "}
              results
            </p>
            <div className="flex gap-3">
              <button
                className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${
                  currentPage === 1 ? "opacity-50" : "opacity-100"
                }`}
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${
                  currentPage === totalPages ? "opacity-50" : "opacity-100"
                }`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="md:px-52 text-center grid text-gray-500 mt-32">
          <div>
            It looks like you don't have any event logs yet. Once you have a log, your log details will appear here.
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditLogs;
